module.exports = __webpack_public_path__ + "static/media/pensosbud_icon.09cd8c17.svg";